// extracted by css-extract-rspack-plugin
export default {"root":"neGde","sticky":"HEqlC","button":"CYwhs"};